import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { ActionItemsTemplatesDashForm, ActionItemsTemplatesDashboard, ActionItemsTemplatesDashboardStore } from '@core/models/action-item-templates/action-item-templates-dashboard.model';
import { noChangesReplacer } from '@shared/helpers';
import { BehaviorSubject, Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ActionItemsTemplatesDashboardStoreService {

  private readonly _initialStoreData: ActionItemsTemplatesDashboardStore = {
    actionItemsTemplatesDash: null,
    sysText: null,
    selectedIndex: null,
    actionItemsTemplatesTab: {
      formInitValues: null,
      matSortData: null,
      pageData: null,
      dashForm: this.fb.group<ActionItemsTemplatesDashForm>({
        searchValue: this.fb.control(null),
        employer: this.fb.control(null),
      })
    },
    actionItemsTab: {
      formInitValues: null,
      matSortData: null,
      pageData: null,
      dashForm: this.fb.group<ActionItemsTemplatesDashForm>({
        searchValue: this.fb.control(null),
        employer: this.fb.control(null)
      })
    }
  };

  private actionItemsTemplatesDashboardStore: BehaviorSubject<ActionItemsTemplatesDashboardStore>;

  private store$: Observable<ActionItemsTemplatesDashboardStore>;

  private readonly templateNames = {
    actionItemsTemplates: "actionItemsTemplates",
    addNewActionItemTemplate: "addNewActionItemTemplate",
    deleteConfirmation: "deleteConfirmation",
    unsavedChanges: "unsavedChanges",
  };

  constructor(private fb: FormBuilder) { 
    this.actionItemsTemplatesDashboardStore = new BehaviorSubject(this._initialStoreData);
    this.store$ = this.actionItemsTemplatesDashboardStore.asObservable();
  }

  public get templates() {
    return this.templateNames;
  }
  
  public get store() {
    return this.actionItemsTemplatesDashboardStore.value;
  }
  
  public get actionItemsTemplatesDash$(): Observable<ActionItemsTemplatesDashboard> {
    return this.store$.pipe(pluck('actionItemsTemplatesDash'));
  }

  public get actionItemsTemplatesDash() {
    return this.store.actionItemsTemplatesDash;
  }

  public set actionItemsTemplatesDash(actionItemsTemplatesDash: ActionItemsTemplatesDashboard) {
    const store = { ...this.store, actionItemsTemplatesDash };
    this.actionItemsTemplatesDashboardStore.next(store);
  }
  
  public get sysText() {
    return this.store.sysText;
  }
  
  public set sysText(sysText: any) {
    const store = { ...this.store, sysText };
    this.actionItemsTemplatesDashboardStore.next(store);
  }

  public get selectedIndex() {
    return this.store.selectedIndex;
  }

  public set selectedIndex(selectedIndex: number) {
    this.store.selectedIndex = selectedIndex;
  }

  // action items templates tab

  public get actionItemsTemplatesTabForm(): FormGroup<ActionItemsTemplatesDashForm> {
    return this.store.actionItemsTemplatesTab.dashForm;
  }

  get actionItemsTemplatesTabFormNoChanges(): boolean {
    return JSON.stringify(this.actionItemsTemplatesTabForm.value, noChangesReplacer) === JSON.stringify(this.store.actionItemsTemplatesTab.formInitValues, noChangesReplacer);
  }

  public set actionItemsTemplatesTabSortData(sortData: Sort) {
    this.store.actionItemsTemplatesTab.matSortData = sortData;
  }

  public get actionItemsTemplatesTabSortData(): Sort {
    return this.store.actionItemsTemplatesTab.matSortData;
  }

  public set actionItemsTemplatesTabPageData(pageData: PageEvent) {
    this.store.actionItemsTemplatesTab.pageData = pageData;
  }

  public get actionItemsTemplatesTabPageData(): PageEvent {
    return this.store.actionItemsTemplatesTab.pageData;
  }

  // action items tab

  public get actionItemsTabForm(): FormGroup<ActionItemsTemplatesDashForm> {
    return this.store.actionItemsTab.dashForm;
  }

  get actionItemsTabFormNoChanges(): boolean {
    return JSON.stringify(this.actionItemsTabForm.value, noChangesReplacer) === JSON.stringify(this.store.actionItemsTab.formInitValues, noChangesReplacer);
  }

  public set actionItemsTabSortData(sortData: Sort) {
    this.store.actionItemsTab.matSortData = sortData;
  }

  public get actionItemsTabSortData(): Sort {
    return this.store.actionItemsTab.matSortData;
  }

  public set actionItemsTabPageData(pageData: PageEvent) {
    this.store.actionItemsTab.pageData = pageData;
  }

  public get actionItemsTabPageData(): PageEvent {
    return this.store.actionItemsTab.pageData;
  }

  public actionItemAssignedToEmployer(actionItemId: number, assigned: boolean) {
    this.store.actionItemsTemplatesDash.actionItems.find(ai => ai.id === actionItemId).assignedToEmployer = assigned;
  }

  public unloadStore() {
    const store: ActionItemsTemplatesDashboardStore = {
      actionItemsTemplatesDash: null,
    sysText: null,
    selectedIndex: null,
    actionItemsTemplatesTab: {
      formInitValues: null,
      matSortData: null,
      pageData: null,
      dashForm: this.fb.group<ActionItemsTemplatesDashForm>({
        searchValue: this.fb.control(null),
        employer: this.fb.control(null),
      })
    },
    actionItemsTab: {
      formInitValues: null,
      matSortData: null,
      pageData: null,
      dashForm: this.fb.group<ActionItemsTemplatesDashForm>({
        searchValue: this.fb.control(null),
        employer: this.fb.control(null)
      })
    }
    }
    this.actionItemsTemplatesDashboardStore.next(store)
  }
}
